(ns manage.variants-preview-panel.db.variants
  (:require [clojure.set :as set]
            [common.util :as util]
            [manage.content-variant-page.table.db :as table.db]
            [mate.core :as mc]
            [re-frame.core :as rf]))

(rf/reg-event-fx :variants-preview.variants/init
  [(rf/inject-cofx :query-params)]
  (fn [{:keys [db query-params]}]
    (let [current-variants (get-in db [:variants-preview.variants :variants])
          values (:resource.content-variants/variants db)
          current-id (or (:id query-params)
                         (-> values
                             first
                             (get-in [:data :content-id])))
          last-cursor (-> values
                          last
                          :cursor)]
      {:db (update db :variants-preview.variants assoc
                   ;;               I swapped values and current-variants around, current-variants was first, why?
                   :variants (->> (concat values current-variants)
                                  (util/distinct-by #(select-keys (:data %) [:content-id :template-dimensions]))
                                  vec
                                  (sort-by (comp :content-id :data)))
                   :current-id current-id
                   :last-cursor last-cursor
                   :external-templates [])})))

(rf/reg-event-fx :variants-preview.variants/next-variant
  [(rf/inject-cofx :sub :variants-preview.variants/next-cursor)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context]
        :variants-preview.variants/keys [next-cursor]} _]
    {:fx [[:router/navigate! [(get-in db [:current-route :data :name])
                              {:params url-context
                               :query (-> db
                                          (get-in [:current-route :query-params])
                                          (dissoc :variant-id)
                                          (assoc :cursor next-cursor))}]]]}))

(defn- find-variant-based-on-targeting
  "Check which variant has targeting passed"
  [variants targeting]
  (filter
   #(or
     (= targeting (set (:targeting-values (:data %))))
     (every? true?
             (for [target targeting]
               (let [targeting-value (some (fn [x] (when (= (:name x) (:name target)) x)) (:targeting-values (:data %)))]
                 (set/subset? (set (:value target)) (set (:value targeting-value))))))) variants))

(defn replace-variant-targeting-with-overrides
  "Replaces variant's targeting values with override values"
  [current-targeting-values targeting-overrides]
  (set (concat (remove #((set (keys targeting-overrides))
                         (:name %))
                       current-targeting-values)
               (map (fn [[k v]] (hash-map :name k :value [v]))
                    targeting-overrides))))

(defn- filter-variants-by-active-status [variants status]
  (if (nil? status)
    variants
    (filter (fn [variant]
              (some #(= (table.db/derive-variant-status (:data variant)) (keyword %)) status))
            variants)))

(rf/reg-event-fx :variants-preview.variants/navigate-to-variant
  [(rf/inject-cofx :sub :variants-preview.variants/variants)
   (rf/inject-cofx :sub :variants-preview.variants-status/filtering-variant-statuses)]
  (fn [{:keys [db]
        :variants-preview.variants/keys [variants]
        :variants-preview.variants-status/keys [filtering-variant-statuses]}
       [_ current-targeting-values targeting-name targeting-value local-drop-down-choices]]
    (let [variants (filter-variants-by-active-status variants filtering-variant-statuses)
          updated-local-drop-down-choices (assoc local-drop-down-choices targeting-name targeting-value)
          replaced-targeting (replace-variant-targeting-with-overrides current-targeting-values updated-local-drop-down-choices)
          found-variants (find-variant-based-on-targeting variants replaced-targeting)
          found-variants-ids (map (comp :id :data) found-variants)
          default-variants (filter #(:default-variant (:data %)) variants)
          default-variants-ids (map (comp :id :data) default-variants)
          navigate-fx (fn [variant-ids drop-down-choices]
                        {:db (-> (assoc-in db [:variants-preview.variants :targeting-selected-variants-ids] variant-ids)
                                 (assoc-in [:resource.content-variants/adjacent :current :data] {:id (first variant-ids)})
                                 (assoc-in [:variants-preview.variants :no-default-variant] false))
                         :fx [[:dispatch [:variants-preview.variants/add-targeting-drop-down-choices drop-down-choices]]]})]
      (cond
        (seq found-variants-ids) (navigate-fx found-variants-ids updated-local-drop-down-choices)
        (seq default-variants) (navigate-fx default-variants-ids updated-local-drop-down-choices)
        :else {:fx [[:dispatch [:variants-preview.variants/add-targeting-drop-down-choice targeting-name targeting-value]]]
               :db (-> (assoc-in db [:variants-preview.variants :no-default-variant] true))}))))

(rf/reg-event-fx :variants-preview.variants/previous-variant
  [(rf/inject-cofx :sub :variants-preview.variants/previous-cursor)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context]
        :variants-preview.variants/keys [previous-cursor]} _]
    {:fx [[:router/navigate! [(get-in db [:current-route :data :name])
                              {:params url-context
                               :query (-> db
                                          (get-in [:current-route :query-params])
                                          (dissoc :variant-id)
                                          (assoc :cursor previous-cursor))}]]]}))

(rf/reg-event-db :variants-preview.variants/reset-targeting-drop-down-choices
  (fn [db [_]]
    (assoc-in db [:variants-preview.variants :targeting-drop-down-choices] {})))

(rf/reg-event-db :variants-preview.variants/add-targeting-drop-down-choices
  (fn [db [_ choices]]
    (assoc-in db [:variants-preview.variants :targeting-drop-down-choices] choices)))

(rf/reg-event-db :variants-preview.variants/add-targeting-drop-down-choice
  (fn [db [_ label value]]
    (assoc-in db [:variants-preview.variants :targeting-drop-down-choices label] value)))

(rf/reg-event-db :variants-preview.variants/add-external-template
  (fn [db [_ template]]
    (update-in db [:variants-preview.variants :external-templates] conj template)))

(rf/reg-event-fx :variants-preview.variants/approve-variant
  [(rf/inject-cofx :sub [:context])]
  (fn [{{:keys [feed-id]} :context} [_ variant-id]]
    {:fx [[:dispatch [:resource.content-variants/approve-many [variant-id]
                      {:feed-id-override feed-id
                       :success-event [:variants-preview.variants/approve-variant-success]}]]]}))

(rf/reg-event-fx :variants-preview.variants/approve-variant-success
  [(rf/inject-cofx :sub :variants-preview.core/display-mode)
   (rf/inject-cofx :sub [:context])]
  (fn [{:keys [:variants-preview.core/display-mode]
        {:keys [cursor]} :context} [_ _variant-id]]
    {:fx [[:dispatch [:response-handler/handle-response
                      {:entity-name "Preview"
                       :type :success
                       :message "Variant approved successfully"}]]
          (if (= display-mode :gallery)
            [:dispatch [:resource.content-variants/get-adjacent cursor]]
            [:dispatch [:resource.content-variants/get-variants-for-preview]])
          (when (not= display-mode :gallery) [:dispatch [:variants-preview.variants/init]])]}))

(rf/reg-event-fx :variants-preview.variants/unapprove-variant
  [(rf/inject-cofx :sub [:context])]
  (fn [{{:keys [feed-id]} :context} [_ variant-id]]
    {:fx [[:dispatch [:resource.content-variants/unapprove-many [variant-id]
                      {:feed-id-override feed-id
                       :success-event [:variants-preview.variants/unapprove-variant-success]}]]]}))

(rf/reg-event-fx :variants-preview.variants/unapprove-variant-success
  [(rf/inject-cofx :sub :variants-preview.core/display-mode)
   (rf/inject-cofx :sub [:context])]
  (fn [{:keys [:variants-preview.core/display-mode]
        {:keys [cursor]} :context} [_ _variant-id]]
    {:fx [[:dispatch [:response-handler/handle-response
                      {:entity-name "Preview"
                       :type :success
                       :message "Variant unapproved successfully"}]]
          (if (= display-mode :gallery)
            [:dispatch [:resource.content-variants/get-adjacent cursor]]
            [:dispatch [:resource.content-variants/get-variants-for-preview]])
          (when (not= display-mode :gallery) [:dispatch [:variants-preview.variants/init]])]}))

(rf/reg-event-fx :variants-preview.variants/init-polling
  [(rf/inject-cofx :sub :variants-preview.core/display-mode)
   (rf/inject-cofx :sub [:context])]
  (fn [{:keys [:variants-preview.core/display-mode]
        {:keys [cursor]} :context} [_ _variant-id]]
    {:fx [(if (= display-mode :gallery)
            [:dispatch [:resource.content-variants/get-adjacent cursor]]
            [:dispatch [:resource.content-variants/get-variants-for-preview]])
          (when (not= display-mode :gallery) [:dispatch [:variants-preview.variants/init]])
          ;; Polling is disabled because it causes shifts in the layout.
          #_[:dispatch-later {:ms 30000 :dispatch [:variants-preview.variants/init-polling]}]]}))

(rf/reg-event-fx :variants-preview.variants/get-content-feed
  [(rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context]} _]
    {:fx [[:dispatch [:resource.feed-importers/get-content-feed (:feed-id url-context)]]]}))

;; Subscriptions

(rf/reg-sub :variants-preview.variants/variants
  (fn [db _]
    (get-in db [:variants-preview.variants :variants])))

(rf/reg-sub :variants-preview.variants/current-data
  (fn [db _]
    (get-in db [:resource.content-variants/adjacent :current :data])))

(rf/reg-sub :variants-preview.variants/current-variant-id
  :<- [:variants-preview.variants/current-data]
  (fn [data _]
    (:id data)))

(rf/reg-sub :variants-preview.variants/current-cursor
  (fn [db _]
    (get-in db [:resource.content-variants/adjacent :current :cursor])))

(rf/reg-sub :variants-preview.variants/next-cursor
  (fn [db _]
    (get-in db [:resource.content-variants/adjacent :next :cursor])))

(rf/reg-sub :variants-preview.variants/previous-cursor
  (fn [db _]
    (get-in db [:resource.content-variants/adjacent :previous :cursor])))

(rf/reg-sub :variants-preview.variants/variants-by-id
  :<- [:variants-preview.variants/current-data] ; this is loaded 1 variant at a time on the gallery view
  :<- [:variants-preview.variants/variants]     ; this is loaded on the side-by-side view
  :<- [:variants-preview.core/display-mode]
  (fn [[current-variant all-variants display-mode] _]
    (if (= display-mode :gallery)
      (mc/index-by :id [current-variant])
      (mc/index-by :id (map :data all-variants)))))

(rf/reg-sub :variants-preview.variants/content-id
  :<- [:variants-preview.variants/variants-by-id]
  (fn [variant-id->variant [_ variant-id]]
    (-> variant-id variant-id->variant
        :content-id)))

(rf/reg-sub :variants-preview.variants/targeting-values
  :<- [:variants-preview.variants/variants-by-id]
  (fn [variant-id->variant [_ variant-id]]
    (-> variant-id variant-id->variant
        :targeting-values)))

(rf/reg-sub :variants-preview.variants/renders
  :<- [:variants-preview.variants/variants-by-id]
  (fn [variant-id->variant [_ variant-id]]
    (-> variant-id variant-id->variant
        :renders)))

(rf/reg-sub :variants-preview.variants/job-result-type
  :<- [:variants-preview.variants/variants-by-id]
  (fn [variant-id->variant [_ variant-id]]
    (-> variant-id variant-id->variant
        (get-in [:renders 0 :job-result :document-type]))))

(rf/reg-sub :variants-preview.variants/url
  :<- [:variants-preview.variants/variants-by-id]
  (fn [variant-id->variant [_ variant-id]]
    (-> variant-id variant-id->variant
        (get-in [:renders 0 :job-result :url]))))

(rf/reg-sub :variants-preview.variants/approval-status
  :<- [:variants-preview.variants/variants-by-id]
  (fn [variant-id->variant [_ variant-id]]
    (-> variant-id variant-id->variant
        :approved)))

(rf/reg-sub :variants-preview.variants/published-status
  :<- [:variants-preview.variants/variants-by-id]
  (fn [variant-id->variant [_ variant-id]]
    (let [published (-> variant-id variant-id->variant
                        :published)
          last-published-ts (-> variant-id variant-id->variant
                                :last-published-ts)]
      (cond
        (and (some? last-published-ts) (not published)) "unpublished"
        (true? published) "published"
        :else nil))))

(rf/reg-sub :variants-preview.variants/createlift-score
  :<- [:variants-preview.variants/variants-by-id]
  (fn [variant-id->variant [_ variant-id]]
    (let [createlift (-> (get variant-id->variant variant-id)
                         :renders
                         first
                         :exports
                         :createlift
                         :assets
                         first)]
      {:score-available (= "done" (:status createlift))
       :score (:score (:data createlift))})))

(rf/reg-sub :variants-preview.variants/adjacent-call-state
  (fn [db _]
    (or (get-in db [:resource.content-variants/adjacent :state]) :pending)))

(rf/reg-sub :variants-preview.variants/values
  :<- [:variants-preview.variants/variants]
  (fn [variants _]
    {:state :success
     :value (->> variants
                 (mapv (fn [variant]
                         (let [{variant-id :id
                                content-id :content-id
                                approved :approved
                                published :published} (:data variant)
                               createlift (-> (:data variant)
                                              :renders
                                              first
                                              :exports
                                              :createlift
                                              :assets
                                              ;; asset for each resolution,
                                              ;; backend probably already fixed to just return one value
                                              first)]
                           {:id variant-id
                            :label content-id
                            :status (cond
                                      published "published"
                                      approved "approved"
                                      :else "draft")
                            :score-available (= "done" (:status createlift))
                            :score (:score (:data createlift))}))))}))

(rf/reg-sub :variants-preview.variants/variants-drop-down-options
  :<- [:variants-preview.variants/variants]
  (fn [variants _]
    (mc/group-by
     :name
     identity
     (fn [acc record]
       (let [value (:value record)]
         (if (> (count value) 1)
           (distinct (flatten (map #(conj acc {:label % :value %}) value)))
           (distinct (conj acc {:label (first value) :value (first value)})))))
     []
     (flatten (map (comp :targeting-values :data) variants)))))

(rf/reg-sub :variants-preview.variants/ordered-selected-variant-ids
  :<- [:table.variant-id/selected-rows]
  :<- [:table.variant-id/value]
  (fn [[selected-rows table-filtered-variants] _]
    (let [selected-variant-ids (set selected-rows)]
      (->> (:value table-filtered-variants)
           (map :id)
           (filterv selected-variant-ids)))))

(rf/reg-sub :variants-preview.variants/targeting-selected-variants-ids
  (fn [db _]
    (get-in db [:variants-preview.variants :targeting-selected-variants-ids])))

(rf/reg-sub :variants-preview.variants/targeting-display-variants-ids
  :<- [:variants-preview.variants/targeting-selected-variants-ids]
  :<- [:variants-preview.variants/variants]
  :<- [:variants-preview.variants-status/filtering-variant-statuses]
  (fn [[selected-variants all-variants filtering-variant-statuses] [_ targeting-values]]
    (let [variants (filter-variants-by-active-status all-variants filtering-variant-statuses)]
      (or selected-variants
          (map (comp :id :data) (find-variant-based-on-targeting variants (set targeting-values)))))))

(rf/reg-sub :variants-preview.variants/strategy-no-default-variant-display-message
  (fn [db _]
    (get-in db [:variants-preview.variants :no-default-variant])))

(rf/reg-sub :variants-preview.variants/targeting-variants-not-approved
  :<- [:variants-preview.variants/variants]
  :<- [:variants-preview.variants-status/filtering-variant-statuses]
  (fn [[all-variants filtering-variant-statuses] [_ targeting-values]]
    (let [filtered-variants (filter-variants-by-active-status all-variants filtering-variant-statuses)]
      (set/difference (set (map (comp :id :data) (find-variant-based-on-targeting all-variants (set targeting-values))))
                      (set (map (comp :id :data) (find-variant-based-on-targeting filtered-variants (set targeting-values))))))))

(rf/reg-sub :variants-preview.variants/next-button-disabled?
  :<- [:variants-preview.variants/next-cursor]
  (fn [next-cursor _]
    (nil? next-cursor)))

(rf/reg-sub :variants-preview.variants/previous-button-disabled?
  :<- [:variants-preview.variants/previous-cursor]
  (fn [previous-cursor _]
    (nil? previous-cursor)))

(rf/reg-sub :variants-preview.variants/currently-displayed
  :<- [:table.variant-id/selected-rows]
  (fn [rows _]
    (count rows)))

(rf/reg-sub :variants-preview.variants/total
  :<- [:table.variant-id/value]
  (fn [value _]
    (count (:value value))))

(rf/reg-sub :variants-preview.variants/external-templates
  (fn [db _]
    (get-in db [:variants-preview.variants :external-templates])))

(rf/reg-sub :variants-preview.variants/targeting-drop-down-choices
  (fn [db _]
    (get-in db [:variants-preview.variants :targeting-drop-down-choices])))

(rf/reg-event-db :variants-preview.variants-status/set-filtering-variant-status
  (fn [db [_ variant-status]]
    (-> (assoc-in db [:variants-preview.variants :filtering-variant-status] variant-status)
        (assoc-in [:variants-preview.variants :targeting-selected-variants-ids] nil))))

(rf/reg-sub :variants-preview.variants-status/filtering-variant-statuses
  (fn [db [_]]
    (get-in db [:variants-preview.variants :filtering-variant-status])))

(rf/reg-sub :variants-preview.variants/is-targeting-configuration-set?
  :<- [:resource.feed-importers/content-feed]
  (fn [content-feed _]
    (case (:state content-feed)
      :success (boolean
                (some (fn [field]
                        (#{"targeting-key"} (:class field)))
                      (get-in content-feed [:value :field-classes])))
      :pending true
      false)))
